let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("efK6k")).then(() => parcelRequire('dSiHJ'));